import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import AbbreviatedNumberTooltip from '../Common/AbbreviatedNumberTooltip';
import { chartLineStyles } from '../Common/ChartUtils';
import PercentTooltip from '../Common/PercentTooltip';
import { calculateRate, getElements } from '../PartnerReports.utils';
export const calculateTotalCount = elements => elements.reduce((total, current) => current.count + total, 0);
export const getCloudConversionsTableData = (cloudConversionsAPIResponse, reportingApps) => {
  const tableData = cloudConversionsAPIResponse.addons.map(response => {
    const evaluationsElements = getElements(response.series, 'Evaluations');
    const conversionsElements = getElements(response.series, 'Conversions');
    const evaluations = calculateTotalCount(evaluationsElements);
    const conversions = calculateTotalCount(conversionsElements);
    return {
      appKey: response.addonKey,
      appName: response.name,
      conversions,
      evaluations,
      conversationRate: calculateRate(evaluations, conversions)
    };
  });
  reportingApps.forEach(app => {
    if (!tableData.some(entry => entry.appKey === app.appKey)) {
      tableData.push({
        appKey: app.appKey,
        appName: app.appName,
        conversions: calculateTotalCount([]),
        evaluations: calculateTotalCount([]),
        conversationRate: calculateRate()
      });
    }
  });
  return tableData;
};
export const getChartLinesDetails = canUseLinePatterns => {
  const lineStyles = chartLineStyles.slice(0, 1);
  return [_objectSpread({
    color: lineStyles[0].color,
    dataKey: 'conversionRate',
    legend: 'Conversion rate'
  }, canUseLinePatterns ? {
    dotStyle: lineStyles[0].dotStyle,
    strokeStyle: lineStyles[0].strokeStyle
  } : {})];
};
export const getChartData = totalSeries => {
  const lineChartData = [];
  const evaluationsElements = getElements(totalSeries, 'Evaluations');
  const conversionsElements = getElements(totalSeries, 'Conversions');
  evaluationsElements.forEach((element, index) => {
    lineChartData.push({
      xLabel: element.date,
      evaluation: element.count,
      conversion: conversionsElements[index].count,
      conversionRate: calculateRate(element.count, conversionsElements[index].count)
    });
  });
  return lineChartData;
};
const getValueFromPayload = (item, key) => {
  const value = item.payload[key];
  return typeof value === 'number' ? value : 0;
};
export const getChartTooltipPairs = (payload, lines) => payload.map((item, index) => {
  const rate = getValueFromPayload(item, 'conversionRate');
  const conversion = getValueFromPayload(item, 'conversion');
  const evaluation = getValueFromPayload(item, 'evaluation');
  return {
    color: item.color,
    label: item.name,
    value: "".concat(rate, "% (").concat(conversion, " / ").concat(evaluation, ")"),
    isCharted: true,
    dotStyle: lines[index].dotStyle,
    strokeStyle: lines[index].strokeStyle
  };
});
export const getColumns = series => {
  const evaluationsElements = getElements(series, 'Evaluations');
  const conversionsElements = getElements(series, 'Conversions');
  const totalEvaluations = calculateTotalCount(evaluationsElements);
  const totalConversions = calculateTotalCount(conversionsElements);
  const conversionRate = calculateRate(totalEvaluations, totalConversions);
  return [{
    key: 'Evaluations',
    content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
      value: totalEvaluations
    })
  }, {
    key: 'Conversions',
    content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
      value: totalConversions
    })
  }, {
    key: 'Conversion rate',
    content: /*#__PURE__*/React.createElement(PercentTooltip, {
      rate: conversionRate
    })
  }];
};
export const getReportColumnsForSeries = series => {
  return getColumns(series);
};

/*
 * This function will return Aggregated feedback series for given app
 * If no app passed, will retutn total series
 */
export const getSeriesByAppName = (apiResponse, appKey) => {
  if (!apiResponse) {
    return [];
  }
  if (appKey) {
    const appKeySeries = apiResponse.addons.find(series => series.addonKey === appKey);
    return appKeySeries ? appKeySeries.series : [];
  }
  return apiResponse.total.series;
};